import { RadioButton, Tooltip } from "@etframework/ui.components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Enums from "../../types/enums";

export const YearCalculationContainer = ({
  initialValue,
  onChange,
  name,
  id,
}) => {
  const [yearCalculationOpt, setYearCalculationOpt] = useState(
    initialValue?.DueDateYearCalculation
  );

  const { t } = useTranslation(["TaskTemplateModal"], {
    useSuspense: false,
  });

  const ids = {
    taxYearEnd: id + "_tax-year-end-radio-button",
    taxYearStart: id + "_tax-year-start-radio-button",
  };

  return (
    <div className="col mt-2 p-4" id={id}>
      <div className="row mx-1 yearCalc-title">
        {t("YearCalculationContainer.Title")}
      </div>
      <div className="row mt-1 yearCalc">
        <div className="ms-2 p-2 yearCalc-radBtn space-y-2">
          <div className="row mx-1 yearCalc-title">
            {t("YearCalculationContainer.Subtitle")}
          </div>
          <div className="row align-self-center my-3">
            <div className="col-6">
              <div className="d-flex">
                <RadioButton
                  id={ids.taxYearStart}
                  label={t("YearCalculationContainer.PeriodStart")}
                  checked={
                    yearCalculationOpt ===
                    Enums.DueDateYearCalculationTypes.PeriodStart
                  }
                  value={"periodstart"}
                  change={(e) => {
                    const newBehavior =
                      e.value === "periodstart"
                        ? Enums.DueDateYearCalculationTypes.PeriodStart
                        : Enums.DueDateYearCalculationTypes.PeriodEnd;
                    setYearCalculationOpt(newBehavior);
                    onChange({
                      DueDateYearCalculation: newBehavior,
                    });
                  }}
                  name={name}
                />
                <div className="px-2">
                  <Tooltip
                    content={() => {
                      return (
                        <span className="p-1">
                          {t("YearCalculationContainer.PeriodStartTooltipMsg")
                            .split("\n")
                            .map((line, index) => (
                              <span key={index}>
                                {line}
                                <br />
                              </span>
                            ))}
                        </span>
                      );
                    }}
                    dark={true}
                    position="TopCenter"
                    showTipPointer={false}
                  >
                    <i className={`fa-regular fa-circle-info icon`}></i>
                  </Tooltip>
                </div>
              </div>
              <div className="mx-4 mt-1 message">
                <div>{t("YearCalculationContainer.PeriodStartMsg1")}</div>

                <div className="d-flex gap-1 mt-2">
                  <div className="expert-tip-msg">
                    <b>{t("YearCalculationContainer.ExpertTip")}</b>{" "}
                    {t("YearCalculationContainer.PeriodStartMsg2")}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex">
                <RadioButton
                  id={ids.taxYearEnd}
                  label={t("YearCalculationContainer.PeriodEnd")}
                  checked={
                    yearCalculationOpt ===
                    Enums.DueDateYearCalculationTypes.PeriodEnd
                  }
                  value={"periodend"}
                  change={(e) => {
                    const newBehavior =
                      e.value === "periodstart"
                        ? Enums.DueDateYearCalculationTypes.PeriodStart
                        : Enums.DueDateYearCalculationTypes.PeriodEnd;
                    setYearCalculationOpt(newBehavior);
                    onChange({
                      DueDateYearCalculation: newBehavior,
                    });
                  }}
                  name={name}
                />
                <div className="px-2">
                  <Tooltip
                    content={() => {
                      return (
                        <span className="p-1">
                          {t("YearCalculationContainer.PeriodEndTooltipMsg")
                            .split("\n")
                            .map((line, index) => (
                              <span key={index}>
                                {line}
                                <br />
                              </span>
                            ))}
                        </span>
                      );
                    }}
                    dark={true}
                    position="TopCenter"
                    showTipPointer={false}
                  >
                    <i className={`fa-regular fa-circle-info icon`}></i>
                  </Tooltip>
                </div>
              </div>
              <div className="mx-4 mt-1 message">
                <div>{t("YearCalculationContainer.PeriodEndMsg1")}</div>

                <div className="d-flex gap-1 mt-2">
                  <div className="expert-tip-msg">
                    <b>{t("YearCalculationContainer.ExpertTip")}</b>{" "}
                    {t("YearCalculationContainer.PeriodEndMsg2")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
